import React from 'react';

// Render elements in editor
// @attributes: array | modifier attributes
// @children: array | leaf's content
// @leaf: object | current leaf's data
const Leaf = ({ attributes, children, leaf }) => {
	if (leaf.bold) {
		children = <strong {...attributes}>{children}</strong>;
	}

	if (leaf.italic) {
		children = <em {...attributes}>{children}</em>;
	}

	if (leaf.underline) {
		children = <u {...attributes}>{children}</u>;
	}

	if (leaf.strikethrough) {
		children = <del {...attributes}>{children}</del>;
	}

	if (leaf.superscript) {
		children = <sup {...attributes}>{children}</sup>;
	}

	if (leaf.subscript) {
		children = <sub {...attributes}>{children}</sub>;
	}

	if (leaf.highlightDefault) {
		children = <mark {...attributes} className="bg-amber-500 text-white rounded">{children}</mark>;
	}

	if (leaf.highlightRed) {
		children = <mark {...attributes} className="bg-red-500 text-white rounded">{children}</mark>;
	}

	if (leaf.highlightYellow) {
		children = <mark {...attributes} className="bg-indigo-500 text-white rounded">{children}</mark>;
	}

	if (leaf.highlightGreen) {
		children = <mark {...attributes} className="bg-emerald-500 text-white rounded">{children}</mark>;
	}

	return <span {...attributes}>{children}</span>;
};

export default Leaf;
